export type RootRouteTarget = 'loading' | 'app' | 'landing'

export function getRootRouteTarget(authReady: boolean, hasAuthenticatedUser: boolean): RootRouteTarget {
  if (!authReady) return 'loading'
  if (hasAuthenticatedUser) return 'app'
  return 'landing'
}
